<div class="customer-selector-wrapper">
	<customer-selector [(selectedId)]="selectedVendorId" (selectedIdChange)="vendorChanged()"> </customer-selector>
</div>
